module.exports = __webpack_public_path__ + "202408221624/img/role_1.ba775b81.png";